import { __decorate, __metadata } from "tslib";
import { Expose, IdItemModel, ItemModelDefinition, ModelId } from '@core/shared/model';
import { UseRestraints } from '@core/shared/restraints';
import { PaymentReminderInteractionRestraints } from "./payment-reminder-interaction.restraints";
import { PaymentReminderItem } from './payment-reminder.item';
// @EditorDefinition({},{allowAllExposed:true, useCrudEndpoint:'admin'})
// @CrudEndpoints({admin:'/admin/...'})
let PaymentReminderInteractionItem = /*#__PURE__*/(() => {
  let PaymentReminderInteractionItem = class PaymentReminderInteractionItem extends IdItemModel {
    toString() {
      return "PaymentReminderInteraction " + this.name;
    }
  };
  __decorate([Expose(), __metadata("design:type", Object)], PaymentReminderInteractionItem.prototype, "creationDate", void 0);
  __decorate([Expose(), __metadata("design:type", PaymentReminderItem)], PaymentReminderInteractionItem.prototype, "reminder", void 0);
  __decorate([Expose(), __metadata("design:type", Number)], PaymentReminderInteractionItem.prototype, "reminderId", void 0);
  __decorate([Expose(), __metadata("design:type", Number)], PaymentReminderInteractionItem.prototype, "userId", void 0);
  __decorate([Expose(), __metadata("design:type", String)], PaymentReminderInteractionItem.prototype, "userName", void 0);
  __decorate([Expose(), __metadata("design:type", String)], PaymentReminderInteractionItem.prototype, "reaction", void 0);
  PaymentReminderInteractionItem = __decorate([ItemModelDefinition({
    texts: {}
  }), UseRestraints(PaymentReminderInteractionRestraints), ModelId("PaymentReminderInteractionItem") // autogenerated by generate-model-ids
  ], PaymentReminderInteractionItem);
  return PaymentReminderInteractionItem;
})();
export { PaymentReminderInteractionItem };